const months = [
  "Янв",
  "Фев",
  "Мар",
  "Апр",
  "Май",
  "Июн",
  "Июл",
  "Авг",
  "Сен",
  "Окт",
  "Ноя",
  "Дек",
];

export default function dateFormat(inputDate) {
  const date = new Date(inputDate);

  const minutes = date.getMinutes();
  const hours = date.getHours();

  const day = date.getDate();
  const month = date.getMonth();
  const year = date.getFullYear();

  return `${day} ${months[month]} ${year} ${formatDecimal(hours)}:${formatDecimal(minutes)}`;
}

function formatDecimal(number) {
  return number < 10 ? `0${number}` : number;
}
